/*@ngInject*/
module.exports = function($rootScope, unitsService) {
    return {
        scope: {
            modalOpened: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
            const vm = this;
            vm.rootScope = $rootScope;
            vm.selectedLocations = [];

            vm.$onInit = function() {
                vm.loadCountyList();
                if(vm.county) {
                    vm.loadUnitList();
                }
            };

            vm.loadCountyList = () => {
                unitsService.getCountyList().then((response) => {
                    vm.countyList = response.data;
                });
            };

            vm.loadUnitList = () => {
                unitsService.getUnitChildren([vm.county[0].id]).then((response) => {
                    vm.unitList = response.data;
                    if(vm.unitList.length === 1) {
                        vm.unit = [vm.unitList[0]];
                    }
                    else if($.map(vm.unitList, item => item.id).indexOf(vm.unit) === -1) {
                        vm.unit = null;
                    }
                    if(vm.unit) {
                        vm.loadInstitutionList();
                    }
                });
            };

            vm.loadInstitutionList = () => {
                unitsService.getUnitChildren([vm.unit[0].id]).then((response) => {
                    vm.institutionList = response.data;
                    if($.map(vm.institutionList, item => item.id).indexOf(vm.institution) === -1) {
                        vm.institution = null;
                    }
                });
            };

            vm.changeObjectCounty = () => {
                if(!vm.selectedLocations.some(item => item.code === vm.county[0].id)){
                    vm.addLocation(vm.county)
                }
                if(vm.county) {
                    vm.loadUnitList();
                }
            };

            vm.changeObjectUnit = () => {
                if(!vm.selectedLocations.some(item => (item.code === vm.unit[0].id || item.code === vm.county[0].id))){
                    vm.addLocation(vm.unit)
                }else{
                    vm.selectedLocations = vm.selectedLocations.filter(item => item.code !== vm.county[0].id);
                    vm.addLocation(vm.unit);
                }
                if(vm.unit) {
                    vm.loadInstitutionList();
                }
            };

            vm.changeObjectInstitution = () => {
                if(!vm.selectedLocations.some(item => (item.code === vm.unit[0].id || item.code === vm.county[0].id || item.code === vm.institution[0].id))){
                    vm.addLocation(vm.institution)
                }else{
                    vm.selectedLocations = vm.selectedLocations.filter(item => item.code !== vm.unit[0].id);
                    vm.addLocation(vm.institution);
                }
            };

            vm.addLocation = (location) => {vm.selectedLocations.push({text: location[0].text, code: location[0].id})};

            vm.removeLocation = (location, index) => {vm.selectedLocations.splice(index, 1);};

            vm.close = () => { vm.rootScope.objectAreaModalOpened = false};

        },
        template: require('./object-area-modal.html')
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-area-modal.directive.js
 **/